import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { FacilitiesActions } from '../../reducers/facilities/actionNames'
import { IFacilities } from '../../reducers/facilities'
import fetchFacilities from '../../models/Facilities/fetchFacilities'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'
import fetchObjectFacilities from '../../models/Facilities/fetchObjectFacilities'

function* loadFacilities() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchFacilities)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchFacilities),
      ),
    ])

    const facilities: IFacilities[] = yield Effects.call(service)
    yield Effects.put({
      type: FacilitiesActions.FacilitiesAccepted,
      payload: facilities,
    })
  } catch (e) {
    console.error(e)
  }
}

function* loadObjectFacilities(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchObjectFacilities)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchObjectFacilities),
      ),
    ])

    const objectId = yield Effects.select(getUserObjectId)

    const facilities: IFacilities[] = yield Effects.call(
      service,
      action.objectId || objectId,
    )
    yield Effects.put({
      type: FacilitiesActions.FacilitiesObjectAccepted,
      payload: facilities,
    })
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeEvery(FacilitiesActions.LoadFacilities, loadFacilities)
  yield Effects.takeEvery(
    FacilitiesActions.LoadObjectFacilities,
    loadObjectFacilities,
  )
}
